export const PERSONAL_ITEM = {
  name: 'personalItem'
};